import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSuggestAnswerForQuestionArgs,
  BackendSuggestAnswerForQuestionPayload,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SuggestAnswerForQuestion(
    $customerId: ID!
    $question: String!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestAnswerForQuestion(
      customerId: $customerId
      question: $question
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      answer
    }
  }
`;

type Variables = BackendMutationSuggestAnswerForQuestionArgs;
type Result = BackendSuggestAnswerForQuestionPayload;

export const suggestAnswerForQuestion = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
